import { ChevronRight } from "lucide-react";

import MonitorIcon from "@repo/ui/assets/icons/MonitorIcon";
import { Button } from "@repo/ui/components";

interface ErrorStateProps {
  title?: string;
  description?: string;
  actionLabel?: string;
  onRetry?: () => void;
  isRetrying?: boolean;
  fullScreen?: boolean;
  as?: "h1" | "h2" | "h4" | "p";
}

const ErrorState = ({
  title = "We couldn't load this section",
  description = "We're having trouble displaying the content right now. this may be temporary. Please try again.",
  actionLabel = "Try again",
  onRetry,
  isRetrying = false,
  fullScreen = false,
  as: Heading = "h4",
}: ErrorStateProps) => {
  const content = (
    <div className="w-full max-w-xl mx-auto text-center">
      <div
        aria-hidden="true"
        className="mx-auto mb-3 flex h-16 w-16 items-center justify-center rounded-full bg-brand-gray-light"
      >
        {/* <Image src={monitor} alt="Error" className="h-7 w-7 text-brand-navy" width={28} height={28} /> */}
        <MonitorIcon width={28} height={28} />
      </div>

      <Heading className="mb-2 text-xl font-bold tracking-tight text-brand-navy ">{title}</Heading>

      <p className="mx-auto mb-3 max-w-md text-base leading-relaxed text-brand-navy/80">
        {description}
      </p>

      {onRetry && (
        <Button
          variant="destructive"
          size="xl"
          onClick={onRetry}
          disabled={isRetrying}
          aria-busy={isRetrying}
        >
          {isRetrying ? "Retrying..." : actionLabel}

          <span
            aria-hidden="true"
            className="ml-1 flex h-6 w-6 items-center justify-center rounded-full border border-primary-foreground/70"
          >
            <ChevronRight className="h-4 w-4" strokeWidth={2.5} />
          </span>
        </Button>
      )}
    </div>
  );

  return (
    <section
      role="alert"
      className={fullScreen ? "flex min-h-[60vh] items-center justify-center" : "w-full"}
    >
      {content}
    </section>
  );
};

export default ErrorState;
